var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.svgClass,attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"role":"presentation"}},[_c(_vm.icon,{tag:"component",attrs:{"fill":_vm.colour}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }